import React from 'react';

import { type PlatformStaffItemFragment } from 'src/api';
import { PlatformStaffDetailModalContent } from 'src/components/clearVerifyStaff';
import { Modal } from 'src/components/common';
import { useModalV2 } from 'src/hooks/shared';
import { type ModalV2Props } from 'src/types/modalV2';

export interface PlatformStaffDetailModalProps {
  platformStaff: PlatformStaffItemFragment;
}

export const PlatformStaffDetailModal: React.FC<ModalV2Props<PlatformStaffDetailModalProps>> = ({
  id,
  platformStaff,
}) => {
  const { closeModal, switchClosability } = useModalV2();

  const onCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Clear Verify Staff Details"
      dialogProps={{
        onClose: onCloseModal,
        open: true,
      }}
    >
      <PlatformStaffDetailModalContent
        platformStaff={platformStaff}
        closeModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
